<div class="links">
  <a
    [attr.href]="baseUrl + '#eula'"
    class="eula"
    role="button"
    tabindex="0"
    (click)="openLegalModal('eula')"
    >{{ 'FOOTER.LEGAL_LINKS.EULA' | translate }}</a
  >

  <a
    [attr.href]="baseUrl + '#privacy-policy'"
    class="privacy-policy"
    role="button"
    tabindex="0"
    (click)="openLegalModal('privacy')"
    >Privacy Policy</a
  >
</div>

<ng-template appComponentLoader></ng-template>
